<template>
  <v-container id="order-list" fluid tag="section">
    <base-material-card outlined icon="mdi-brightness-7" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Cài đặt khách hàng</div>
      </template>

      <div class="text-sm-right pa-5">
        <v-btn
          v-if="checkAuthorization('contact-setting_create')"
          @click="addContactSetting"
          class="primary mx-0"
          
        >
          <v-icon>mdi-plus</v-icon>Thêm
        </v-btn>
      </div>
      <!--  -->

      <v-simple-table class="table-layout pa-5 table-contact" v-show="objectList.length > 0"> 
        <template v-slot:default>
          <thead>
            <tr>
              <th>Tên miền</th>
              <th>Tên</th>
              <th>Băt buộc</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody
            class="bg-hover"
            v-for="(objectValue, objectIndex) in objectList"
            :key="'object_' + objectIndex"
          >
            <tr
              v-for="(dataAttribute, index) in contactColumns[objectValue]"
              :key="'attribute_' + index"
            >
              <td :rowspan="contactColumns[objectValue].length" v-if="index === 0">
                {{getObjectText(objectValue)}}
              </td>
              <!-- <td>{{dataAttribute.name}}</td> -->
              <td>{{dataAttribute.description}}</td>
              <td>{{getRequiredText(dataAttribute.isRequired)}}</td>
              <td>
                <div class="action">
                  <v-tooltip bottom v-if="checkAuthorization('contact-setting_update')">
                    <template v-slot:activator="{ on }">
                      <v-btn @click="clickUpdateContactAttribute(dataAttribute)" class="mr-2" icon small color="primary" v-on="on">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Cập nhật thuộc tính</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('contact-setting_delete')">
                    <template v-slot:activator="{ on }">
                      <v-btn @click="clickRemoveContactAttribute(dataAttribute.id)" icon small color="default" v-on="on">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Xoá thuộc tính</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </base-material-card>
    <modal-contact-setting
      v-if="filterForm.openModal"
      :filter-form="filterForm"
      :dataAttributeOld="dataAttribute"
    />
  </v-container>
</template>

<script>
import ModalContactSetting from './components/ModalContactSetting';
import {
  contactSettingObjects,
} from '../../helpers/constants';

import RepositoryFactory from '../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');

export default {
  components: {
    ModalContactSetting
  },
  data() {
    return {
      filterForm: {
        isCreate: true,
        openModal: false,
      },
      dataAttribute: {},
      objectList: [],
      contactColumns: {},
    };
  },
  created() {
    this.getContactColumns();
    Bus.$on('contact-setting-list', () => {
      this.getContactColumns();
    });
  },
  beforeDestroy() {
    Bus.$off('contact-setting-list');
  },
  methods: {
    clickUpdateContactAttribute(dataAttribute) {
      this.dataAttribute = { ...dataAttribute};
      this.filterForm.openModal = true;
    },
    getObjectText(objectValue) {
      const dataObject = contactSettingObjects.find(data => data.value === objectValue);
      if (!dataObject) {
        return '';
      }
      return dataObject.text;
    },
    async getContactColumns() {
      const loader = this.$loading.show();
      const response = await ContactRepository.getContactColumns();
      loader.hide();
      this.loading = false;
      if (response.success) {
        this.contactColumns = _.get(response, 'data', {});
        this.objectList = Object.keys(this.contactColumns);
      } else {
        this.objectList = [];
        this.contactColumns = {};
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    getRequiredText(value) {
      return value === true ? 'Có' : 'Không';
    },
    addContactSetting() {
      this.dataAttribute = {};
      this.filterForm.openModal = true;
    },
    clickRemoveContactAttribute(id) {
      this.$swal({
          title: 'Xóa thuộc tính khách hàng',
          text: 'Bạn có thực sự muốn xoá ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const respond = await ContactRepository.deleteContactColumn(id)
            loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Xoá thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                this.getContactColumns();
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
    },
  }
};
</script>
<style scoped>
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
</style>